import { render, staticRenderFns } from "./beam-menu.vue?vue&type=template&id=9257c012&"
import script from "./beam-menu.vue?vue&type=script&lang=js&"
export * from "./beam-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports